<!-- classic input -->
<div class="input-group-append calendar bg-white align-items-center" *ngIf="!isRangeInput && !isDisplayedRange" [ngClass]="{'d-none': hideButton}">
  <button class="btn " (click)="d.toggle()" type="button">
    <i class="fa fa-calendar"></i>
  </button>
</div>
<div *ngIf="isRangeInput && !isContainer">

  <div class="form-group hidden border-0 p-0 m-0">
    <div class="input-group">
      <input class="form-control d-none"
             ngbDatepicker
             #hideput="ngbDatepicker"
             [autoClose]="false"
             (dateSelect)="onDateSelection($event)"
             [displayMonths]="1"
             [dayTemplate]="t"
             outsideDays="hidden"
             [startDate]="fromDate"
             [minDate]="calendarMinDate"
             [maxDate]="calendarMaxDate"
             [footerTemplate]="footer"
             [markDisabled]="isDisabled"
             >
      <ng-template #t let-date let-focused="focused" >
       <span class="custom-day"
             [class.focused]="focused"
             [class.range]="isRange(date)"
             [class.faded]="isHovered(date) || isInside(date)"
             (mouseenter)="hoveredDate = date"
             (mouseleave)="hoveredDate = null"
             [class.endDate]="isEndDate(date)"
             [class.startDate]="isStartDate(date)"
             [class.hovered]="isHoverDate(date)"
         matTooltip="{{ getTooltipContent(date) | translate:{value: room && room.minimal_stay_duration ? room.minimal_stay_duration : '3'} }}"
             matTooltipClass="calendar_tooltip">
            {{ date.day }}
       </span>
      </ng-template>
      <ng-template #footer>
        <div class="cal-head" *ngIf="room">
          {{ 'PROCESSES.ACCOMMODATION.RESERVATION.MIN2' | translate:{value: room && room.minimal_stay_duration ? room.minimal_stay_duration : '3'} }}
        </div>
        <p class="footer pt-1 text-info text-center w-100 position-absolute pb-3">
          <button class="btn font-12 py-0 px-2" (click)="backToCurrentDay()">{{ "COMMON.TODAY" | translate }}</button>
          <button class="btn font-12 py-0 px-2 ms-2" (click)="clear()">{{ "COMMON.CLEAR" | translate }}</button>
          <button class="btn font-12 py-0 px-2 ms-5" (click)="closeCalendar.emit(true)" *ngIf="isMobile">&times; {{ 'COMMON.CLOSE' | translate }}</button>
        </p>
      </ng-template>
    </div>
  </div>

  <div class="input-group-append calendar bg-white align-items-center" [ngClass]="{'d-none': hideButton}">
    <button class="btn small text-primary" (click)="hideput.toggle()" type="button"><i class="fa fa-calendar"></i></button>
  </div>
</div>

<!-- DATE PROPOSAL CALENDAR, ALWAYS DISPLAYED -->
<div *ngIf="isDisplayedRange && !isContainer">
  <ngb-datepicker class="version2 bg-white"
    (dateSelect)="onDateSelection($event)" [displayMonths]="1" [dayTemplate]="t"
    outsideDays="hidden" [minDate]="calendarMinDate" [markDisabled]="isDisabled" [maxDate]="calendarMaxDate">
    <ng-template #t let-date let-focused="focused">
      <span class="custom-day"
            [class.focused]="focused"
            [class.range]="isRange(date) "
            [class.faded]="isHovered(date) || isInside(date) || (isUserReselect && isPreSetDate(date))"
            (mouseenter)="hoveredDate = date"
            (mouseleave)="hoveredDate = null"
            [class.endDate]="!isForcedDate && isEndDate(date)"
            [class.startDate]="!isForcedDate && isStartDate(date)"
            [class.hovered]="isHoverDate(date)"
            [class.userSelection]="isSelectedDate(date, true)"
            [class.selected]="isUserReselect && isSelectedDate(date, false)"
            matTooltip="{{ getTooltipContent(date) | translate}}"
            matTooltipClass="calendar_tooltip">
        {{ date.day }}
      </span>
    </ng-template>
  </ngb-datepicker>
</div>

<!-- DATE CONTAINER -->

<div class="calendar_container" *ngIf="isContainer && isRangeInput" [ngClass]="{'isMobile': isMobile}">
  <ngb-datepicker class="version3 bg-white" #hideput="ngbDatepicker"
    (dateSelect)="onDateSelection($event)" [displayMonths]="1" [dayTemplate]="t"
    outsideDays="hidden" [minDate]="calendarMinDate" [startDate]="fromDate"
    [markDisabled]="isDisabled" [maxDate]="calendarMaxDate">
    <ng-template #t let-date let-focused="focused">
      <span class="custom-day font-trueno-light"
        [class.focused]="focused"
        [class.range]="isRange(date) "
        [class.faded]="isHovered(date) || isInside(date) || (isUserReselect && isPreSetDate(date))"
        (mouseenter)="hoveredDate = date"
        (mouseleave)="hoveredDate = null"
        [class.endDate]="!isForcedDate && isEndDate(date)"
        [class.startDate]="!isForcedDate && isStartDate(date)"
        [class.hovered]="isHoverDate(date)"
        [class.lastday]="isLastDay(date)"
        [class.userSelection]="isSelectedDate(date, true)"
        [class.selected]="isUserReselect && isSelectedDate(date, false)"
        triggers="mouseenter:mouseleave:manual"
        #RM="matTooltip"
        (click)="RM.show()"
        matTooltip="{{ getTooltipContent(date) | translate:{value: room && room.minimal_stay_duration ? room.minimal_stay_duration : '3'} }}"
        [matTooltipClass]="['calendar_tooltip', getDateDay(date)]">
        {{ date.day }}
      </span>
    </ng-template>

  </ngb-datepicker>

</div>
